// extracted by css-extract-rspack-plugin
export default {"error":"FFC3Si8fAoNTakxi"};